import React, { useState } from 'react';
import CompanyChecklist from './CompanyChecklist';

/**
 * Alta de un despacho o de un abogado: datos de contacto y clientes. La
 * contraseña la fija el usuario con el email de restablecimiento que recibe.
 */
function NewUserForm({ title, companies, onSubmit, onCancel }) {
  const [form, setForm] = useState({ name: '', lastname: '', email: '', phone: '' });
  const [companyIds, setCompanyIds] = useState([]);
  const [saving, setSaving] = useState(false);

  const set = field => e => setForm(prev => ({ ...prev, [field]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    setSaving(true);
    try {
      await onSubmit({ ...form, company_ids: companyIds });
    } finally {
      setSaving(false);
    }
  };

  const input = 'w-full rounded-lg border-slate-300 text-sm focus:ring-blue-500 focus:border-blue-500';

  return (
    <form onSubmit={handleSubmit} className='bg-slate-50 border border-slate-200 rounded-lg p-4 space-y-3'>
      <h3 className='text-sm font-semibold text-slate-800'>{title}</h3>
      <div className='grid grid-cols-1 sm:grid-cols-2 gap-3'>
        <input className={input} placeholder='Nombre' value={form.name} onChange={set('name')} required />
        <input className={input} placeholder='Apellidos' value={form.lastname} onChange={set('lastname')} />
        <input className={input} type='email' placeholder='Email' value={form.email} onChange={set('email')} required />
        <input className={input} placeholder='Teléfono' value={form.phone} onChange={set('phone')} required />
      </div>
      <div>
        <span className='block text-xs font-medium text-slate-600 mb-1'>Clientes que ve</span>
        <CompanyChecklist companies={companies} selected={companyIds} onChange={setCompanyIds} />
      </div>
      <p className='text-xs text-slate-500'>Recibirá un email para fijar su contraseña.</p>
      <div className='flex justify-end gap-2'>
        <button
          type='button'
          onClick={onCancel}
          className='px-3 py-1.5 text-sm rounded-lg border border-slate-300 text-slate-600 hover:bg-white'
        >
          Cancelar
        </button>
        <button
          type='submit'
          disabled={saving}
          className='px-3 py-1.5 text-sm rounded-lg bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50'
        >
          {saving ? 'Creando…' : 'Crear'}
        </button>
      </div>
    </form>
  );
}

export default NewUserForm;
